<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<!-- {{"ADD" | translate }} {{"CONDPG" | translate }} -->
<div mat-dialog-content>
  <mat-card class="p-0">
    <mat-tab-group>
      <mat-tab label="Condição de Pagamento">
        <form [formGroup]="itemForm" >
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="50" class="pr-1">
              <mat-form-field>
                <input required  matInput name="codigo" matInput type="number"
                  [formControl]="itemForm.controls['codigo']" placeholder="Código">
              </mat-form-field>
              <small *ngIf="itemForm.controls['codigo'].hasError('required') && itemForm.controls['codigo'].touched"
                class="form-error-msg"> Código é obrigatório </small>
            </div>

            <div fxFlex="50" class="pr-1">
              <section>
                <mat-checkbox name="desativado" [formControl]="itemForm.controls['desativado']">Desativado?
                </mat-checkbox>
              </section>
            </div>


            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput name="descricao" matInput type="text"
                  [formControl]="itemForm.controls['descricao']" placeholder="Descrição">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['descricao'].hasError('required') && itemForm.controls['descricao'].touched"
                class="form-error-msg"> Descrição é obrigatório </small>
            </div>

            <div fxFlex="50" class="pr-1">
              <mat-form-field>
                <input required  matInput type="number" name="parcelas"
                  [formControl]="itemForm.controls['parcelas']" placeholder="Nº de Parcelas">
              </mat-form-field>
              <small *ngIf="itemForm.controls['parcelas'].hasError('required') && itemForm.controls['parcelas'].touched"
                class="form-error-msg"> Nº de Parcelas é obrigatório </small>
            </div>

            <!-- <div fxFlex="50" class="pr-1"> -->
            <div fxFlex="100" class="pr-1">
              <mat-form-field>
                <input required  matInput type="number" name="percDescontoMin"
                  [formControl]="itemForm.controls['percDescontoMin']" placeholder="Desconto Mínimo (%)">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['percDescontoMin'].hasError('required') && itemForm.controls['percDescontoMin'].touched"
                class="form-error-msg"> Desconto Mínimo é obrigatório </small>
            </div>
            <div fxFlex="100" class="pr-1">
              <mat-form-field>
                <input required  matInput type="number" name="percDescontoMax"
                  [formControl]="itemForm.controls['percDescontoMax']" placeholder="Desconto Máximo (%)">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['percDescontoMax'].hasError('required') && itemForm.controls['percDescontoMax'].touched"
                class="form-error-msg"> Desconto Máximo é obrigatório </small>
            </div>
            <div fxFlex="100" class="pr-1">
              <mat-form-field>
                <input required  matInput type="number" name="percDescontoPadrao"
                  [formControl]="itemForm.controls['percDescontoPadrao']" placeholder="Desconto Padrão (%)">
              </mat-form-field>
              <mat-error
                *ngIf="itemForm.controls['percDescontoPadrao'].hasError('required') && itemForm.controls['percDescontoPadrao'].touched"
                class="form-error-msg"> Desconto Padrão é obrigatório </mat-error>
            </div>
            <!-- </div> -->

            <div fxFlex="100" class="pr-1">
              <mat-form-field>
                <mat-label>Selecione o Tipo </mat-label>
                <select matNativeControl required [formControl]="itemForm.controls['prazoParcelas']">
                  <option value="Diario">Diário</option>
                  <option value="Mensal">Mensal</option>
                </select>
                <mat-error
                  *ngIf="itemForm.controls['prazoParcelas'].hasError('required') && itemForm.controls['prazoParcelas'].touched"
                  class="form-error-msg">
                  Prazo Parcelas é obrigatório
                </mat-error>
                <!-- <mat-hint>Selecione o tipo p/ o vencimento da parcela</mat-hint> -->
              </mat-form-field>

            </div>
            <div fxFlex="100" class="pr-1">
              <mat-form-field>
                <mat-label>Vencimento a Partir da </mat-label>
                <select matNativeControl required [formControl]="itemForm.controls['vctoAPartir']">
                  <option value="Data de Emissao">Data de Emissão</option>
                  <option value="Data de Entrada/Saida">Data de Entrada/Saída</option>
                </select>
                <mat-error
                  *ngIf="itemForm.controls['vctoAPartir'].hasError('required') && itemForm.controls['vctoAPartir'].touched"
                  class="form-error-msg">
                  Prazo Parcelas é obrigatório
                </mat-error>
                <!-- <mat-hint>Selecione o tipo p/ o vencimento da parcela</mat-hint> -->
              </mat-form-field>
            </div>

            <div>
              <section>
                <mat-checkbox name="alteraParcela" [formControl]="itemForm.controls['alteraParcela']">Permitir alterar
                  parcelas?</mat-checkbox>
              </section>
            </div>

            <div fxFlex="100" class="mt-1">
             
            </div>
          </div>
        </form>
      </mat-tab>

      <mat-tab label="Lista de Parcelas" *ngIf="!this.saving">
          <form [formGroup]="_parcelaForm" (keydown.enter)="$event.preventDefault()">
            <ngx-datatable 
              class="material ml-0 mr-0" 
              [rows]="(this.parcelaList$ | async)" 
              [headerHeight]="50"
              [footerHeight]="50" 
              [messages]="{emptyMessage:'Nenhuma lista de parcela encontrada'}" 
              [scrollbarH]="true"
              [scrollbarV]="true"
              [rowHeight]="60">
              <ngx-datatable-column name="#" [width]="25">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                  <strong>{{ rowIndex+1 }}</strong>
                </ng-template>
              </ngx-datatable-column>
  
              <!-- Edit Button  -->
  
                <ngx-datatable-column [name]="'Editar'" [flexGrow]="0.5">
                    <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>

                      <button mat-icon-button color="primary" *ngIf="!this.isEditable[rowIndex]"
                        (click)="this.isEditable[rowIndex]=!this.isEditable[rowIndex];this.buildParcelaForm(row)">
                        <mat-icon>edit</mat-icon>
                      </button>
      
                      <button mat-icon-button  *ngIf="this.isEditable[rowIndex]" (click)="saveRow(rowIndex)">
                        <mat-icon>save</mat-icon>
                      </button>
                    </ng-template>
              
                </ngx-datatable-column>
  
  
              <ngx-datatable-column name="Parcela" [flexGrow]="1">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <span>
                    {{ row?.parcela.toString().padStart(3, '0') }}
                  </span>
                </ng-template>
              </ngx-datatable-column>
  
              <ngx-datatable-column name="Dias" [flexGrow]="1" >
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditable[rowIndex]">
                    {{ row?.diasEmissao.toString().padStart(3, '0') }}
                  </ng-container>
                  <ng-container *ngIf="isEditable[rowIndex]">
                    <mat-form-field>
                      <input matInput autofocus  type="number" value="diasEmissao" formControlName="diasEmissao" />
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
  
              <ngx-datatable-column name="(%)" [flexGrow]="1">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditable[rowIndex]">
                    {{ row?.percentual | number : '1.5-5'}}
                  </ng-container>
                  <ng-container *ngIf="isEditable[rowIndex]">
                    <mat-form-field>
                      <input matInput   type="number" formControlName="percentual">
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
  
              
              <ngx-datatable-column name="Portador" [flexGrow]="1">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditable[rowIndex]">
                    {{ (row?.financPortador?.codigo??'0').toString().padStart(3, '0') + '-' + row?.financPortador?.descricao }}
                  </ng-container>
                  <ng-container *ngIf="isEditable[rowIndex]">

                    <mat-form-field class="full-width">
                      <mat-label>Portador</mat-label>
                      <mat-select  [formControl]="this._parcelaForm?.controls['financPortador']" (selectionChange)="onSelectionChangePortador($event)">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="this._parcelaForm?.controls['searchPortador']!"
                            placeholderLabel="Pesquisar Portador.." noEntriesFoundLabel="Portador não encontrada"
                            [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let portador of portadores" [value]="portador">
                          <span>{{ (portador?.codigo??'0').toString().padStart(3, '0') + '-' + portador?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
  
              <ngx-datatable-column name="Tipo Cobrança" [flexGrow]="1">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditable[rowIndex]">
                    {{ (row?.financTipoCobranca?.codigo??'0').toString().padStart(3, '0') + '-' + row?.financTipoCobranca?.descricao}}
                  </ng-container>
                  <ng-container *ngIf="isEditable[rowIndex]">

                    <mat-form-field class="full-width">
                      <mat-label>TipoCobranca</mat-label>
                      <mat-select  [formControl]="this._parcelaForm?.controls['financTipoCobranca']" (selectionChange)="onSelectionChangeTipoCobranca($event)">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="this._parcelaForm?.controls['searchTipoCobranca']!"
                            placeholderLabel="Pesquisar Tipo Cobranca" noEntriesFoundLabel="Tipo Cobranca encontrada"
                            [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let tipoCobranca of tipoCobrancas" [value]="tipoCobranca">
                          <span>{{ (tipoCobranca?.codigo??'0').toString()?.padStart(3, '0') + '-' + tipoCobranca?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                   
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
  
              <ngx-datatable-column name="Classe Gerencial" [flexGrow]="1">
                <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngIf="!isEditable[rowIndex] && row.financClassificacaoG">
                    {{ (row?.financClassificacaoG?.classificacao??'0') + '-' + row?.financClassificacaoG?.descricao }}
                  </ng-container>
                  <ng-container *ngIf="isEditable[rowIndex]">

                    <mat-form-field class="full-width">
                      <mat-label>Classificação Gerencial</mat-label>
                      <mat-select  [formControl]="this._parcelaForm?.controls['financClassificacaoG']" (selectionChange)="onSelectionChangeClassificacaoG($event)">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="this._parcelaForm?.controls['searchClassificacaoG']!"
                            placeholderLabel="Pesquisar Classificação Gerencial" noEntriesFoundLabel="Classificação Gerencial não encontrada"
                            [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let classificacaoG of classificacaoGs" [value]="classificacaoG">
                          <span>{{ (classificacaoG?.classificacao??'0') + '-' + classificacaoG?.descricao }}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                  
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </form>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>

<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <button class="mb-8" mat-raised-button [matTooltip]="'Salvar Condição de Pgto'" color="primary" [disabled]="itemForm?.invalid"
      (click)="this.save();$event.preventDefault();">
      <mat-icon>save</mat-icon>  <ng-container *ngIf="!layoutConf.isMobile"> {{"SAVE" |translate }} </ng-container>
    </button>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>